import { BASE_ENV } from './constants';

import getConfig from './lib/get-config';
import queryString from './lib/query-string';

const platform = (queryString('platform') || 'vic').toLowerCase();
const config = getConfig(BASE_ENV, platform);
config.env = BASE_ENV;

export default config;